export const getCommentContent = (content) => {
    try {
        return content ? JSON.parse(content) : undefined;
    }
    catch (_a) {
        return undefined;
    }
};
//# sourceMappingURL=get-comment-content.js.map